module.exports = __webpack_public_path__ + "static/media/downloadInvoicePdf.dbdfd070.png";